// React
import React from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";

function Form({
  bootStrapClass,
  buttonDisabled,
  buttonLeft,
  buttonText,
  children,
  containerStyle,
  handleSubmit,
  onSubmit,
  t,
  title,
  onBackButtonClick,
  backButtonText,
  backButton
}) {
  return (
    <div className="col-sm-12">
      <div id="content" style={{ paddingTop: 0, marginTop: 50 }}>
        <div
          className="row"
          style={{
            ...containerStyle,
            display: `block`
          }}
        >
          <div className={bootStrapClass}>
            <form
              autoComplete="off"
              id="checkout-form"
              className="smart-form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <header
                style={{
                  alignItems: `center`,
                  display: `flex`,
                  flexDirection: `row`,
                  padding: 15,
                  margin: 0
                }}
              >
                <span className="widget-icon">
                  <i className="fa fa-edit" />
                </span>
                <h2 style={{ marginLeft: 5 }}>
                  {title || t(`modules.localization.register.authenticated.common.form.title`)}
                </h2>
              </header>
              {children}
              <footer>
                <button
                  disabled={buttonDisabled}
                  className="btn btn-primary"
                  style={{
                    float: buttonLeft ? `left` : `right`
                  }}
                  type="submit"
                >
                  {buttonText ||
                    t(`modules.localization.register.authenticated.common.button.submit`)}
                </button>
                {backButton && (
                  <button
                    className="btn btn-default"
                    style={{
                      float: buttonLeft ? `left` : `right`
                    }}
                    onClick={onBackButtonClick}
                    type="button"
                  >
                    {backButtonText}
                  </button>
                )}
              </footer>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

Form.defaultProps = {
  bootStrapClass: `col-sm-12 col-md-12 col-lg-6`,
  buttonDisabled: false,
  buttonLeft: false
};

Form.propTypes = {
  bootStrapClass: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  buttonLeft: PropTypes.bool,
  buttonText: PropTypes.string,
  children: PropTypes.node,
  containerStyle: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
  onBackButtonClick: PropTypes.func,
  backButtonText: PropTypes.string,
  backButton: PropTypes.bool
};

export default withNamespaces()(Form);
